mutation AttachPlatformEditablesToCampaignMutation($campaignId: ID!, $publishingPlatform: String) {
    attachPlatformEditablesToCampaign(campaignId: $campaignId, publishingPlatform: $publishingPlatform)
}
